<template>
    <aside class="filters aside d-md-block" :class="{'d-none': !showFilters}">
        <!--<section class="aside-section">
            <div class="aside-category">
                <h4 class="aside-section__main-title">دسته بندی ها</h4>
                <div class="aside-category__item">
                    <a class="aside-category__title" href="#"><span class="icon-Chevron_left aside-category__icon"></span> یخچال و فریزر</a>
                    <nav class="nav flex-column aside-category__nav">
                        <a class="nav-link aside-category__nav-link" href="#">ساید بای ساید</a>
                        <a class="nav-link aside-category__nav-link" href="#">یخچال فریزر دو قلو</a>
                        <a class="nav-link aside-category__nav-link" href="#">یخچال فریزر پایین</a>
                        <a class="nav-link aside-category__nav-link" href="#">یخچال فریزر بالا</a>
                    </nav>
                </div>
            </div>
        </section>-->
        <section class="d-none filters__header">
            <span class="title">فیلتر نتایج جستجو</span>
            <button @click="showFilters = false"><i class="fa fa-close"></i></button>
        </section>
        <section class="aside-section">
            <sidebar-true-false
                name="stock_status"
                label="فقط کالاهای موجود"
            />
            <sidebar-true-false
                name="special_offers"
                label="فقط کالاهای تخفیف دار"
            />
            <div class="accordion custom-accordion" id="searchAccordion">
                <div class="accordion-item custom-accordion__item">
                    <h2 class="accordion-header custom-accordion__header" id="searchAccordion-headingOne">
                        <button
                            aria-controls="searchAccordion-collapseOne"
                            aria-expanded="true"
                            class="accordion-button custom-accordion__button"
                            data-bs-target="#searchAccordion-collapseOne"
                            data-bs-toggle="collapse" type="button">جستجو در نتایج</button>
                    </h2>
                    <div aria-labelledby="searchAccordion-headingOne" class="accordion-collapse collapse custom-accordion__collapse show" id="searchAccordion-collapseOne">
                        <div class="accordion-body custom-accordion__body">
                            <form class="custom-search-form">
                                <div class="input-group mb-3">
                                    <button class=" input-group-text custom-search-form__icon" id="basic-addon1">
                                        <span class="icon-Search"></span></button>
                                    <input aria-describedby="basic-addon1" aria-label="Username"
                                           class=" form-control custom-search-form__text-input" placeholder="نام کالا یا برند..." type="text">
                                </div>
                            </form>
                            <form class="custom-range-form">
                                <div class="slider-labels">
                                    <div class="caption">
                                        <span id="slider-range-value1"></span>
                                    </div>
                                    <div class="caption">
                                        <span>تا</span>
                                    </div>
                                    <div class="caption">
                                        <span id="slider-range-value2"></span>
                                    </div>
                                </div>
                                <div id="slider-range"></div>
                                <div class="slider__monetary-unit">
                                    <span>تومان</span> <span>تومان</span>
                                </div>
                                <button class="btn custom-btn custom-range-form__btn">اعمال فیلتر</button>
                            </form>
                            <div class="row">
                                <div class="col-sm-12">
                                    <form>
                                        <!-- <input type="hidden" name="min-value" value="" /><input type="hidden" name="max-value" value="" /> -->
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <sidebar-filter :items="available_filters.brands" label="برند" filter-key="brand"/>
            <sidebar-filter v-for="attr in available_filters.attributes"
                            :items="attr.entities"
                            type="attribute"
                            :label="attr.title"
                            :filter-key="`attr${attr.id}`"
            />
        </section>
        <button class="btn btn-success d-none filters__see_result" @click="showFilters = false">مشاهده نتایج</button>
    </aside>
</template>

<script>
import SidebarFilter from "./SidebarFilter";
import SidebarTrueFalse from "./SidebarTrueFalse";
export default {
    name: "Sidebar",
    components: {SidebarTrueFalse, SidebarFilter},
    props: {
        result: {type: String, required: true}
    },
    data() {
        return {

        }
    },
    computed: {
        available_filters() {
            return this.$store.state.archive.available_filters;
        },
        request() {
            return this.$store.state.archive.request;
        },
        trigger() {
            return this.$store.state.archive.request.trigger;
        },
        loading: {
            get() {
                return this.$store.state.archive.loading;
            },
            set(value) {
                this.$store.commit('archive/setLoading', value);
            }
        },
        showFilters: {
            get() {
                return this.$store.state.archive.showFilters;
            },
            set(value) {
                this.$store.commit('archive/setShowFilters', value);
            }
        }
    },
    watch: {
        result() {
            this.$store.commit('archive/setResult', JSON.parse(this.result));
        },
        trigger() {
            this.getResults();
        }
    },
    methods: {
        getResults() {
            this.loading = true;
            const basePath = window.location.href.includes('?') ?
                window.location.href.substring(0, window.location.href.indexOf('?')) :
                window.location.href.includes('#') ?
                    window.location.href.substring(0, window.location.href.indexOf('#')) :
                    window.location.href;

            const request = {};
            Object.entries(this.request).map(entry => {
                if (entry[0]==='trigger') {
                    return;
                }
                if (typeof entry[1] === "object" && entry[1] !== null) {
                    if (entry[1].length) {
                        request[entry[0]] = entry[1];
                    }
                } else {
                    if (!!entry[1]) {
                        request[entry[0]] = entry[1];
                    }
                }
            });

            const query =  new URLSearchParams(request).toString();
            const config = {
                headers: {
                    Accept: "application/json",
                },
            };

            this.axios.get(basePath+'?'+query, config).then(response => {
                this.loading = false;
                this.$store.commit('archive/setResult', response.data);
                window.scrollTo({top: 0, behavior: 'smooth'});
            }).catch(error => {
                console.error('Error happened on archive result: ', error);
                this.loading = false;
                window.scrollTo({top: 0, behavior: 'smooth'});
            });
        }
    },
    mounted() {
        this.$store.commit('archive/setResult', JSON.parse(this.result));
    },
}
</script>

<style scoped>

</style>
